import { jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useOnClickOutside } from "@crehana/react-hooks";
import { clsx } from "clsx";
import { generalContainerClassName, iconsClassName, stateContainerClassName } from "./constants.js";
const FormElementContainer = ({ size = 'sm', leadingIcon, fieldState, trailingIcon, leadingElement, trailingElement, draggable, onDrag, onDragStart, onDragEnd, formElement, onClickOutside = ()=>{} })=>{
    const containerRef = useRef(null);
    useOnClickOutside(containerRef, onClickOutside);
    useEffect(()=>{
        const divElement = containerRef.current;
        if (!divElement) return;
        const focusListener = ()=>divElement.querySelector('input')?.focus();
        divElement.addEventListener('click', focusListener);
        return ()=>divElement.removeEventListener('click', focusListener);
    }, [
        containerRef
    ]);
    return /*#__PURE__*/ jsxs("div", {
        ref: containerRef,
        className: clsx(generalContainerClassName, 'sm' === size ? 'tw-h-4 tw-font-body4' : 'tw-h-5.6 tw-font-body3', stateContainerClassName[fieldState]),
        draggable: draggable,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        onDrag: onDrag,
        children: [
            leadingIcon && !leadingElement && leadingIcon({
                size: 24,
                className: clsx(iconsClassName[fieldState], 'tw-ml-1.2 tw-shrink-0')
            }),
            leadingElement,
            formElement,
            trailingElement,
            trailingIcon && !trailingElement && trailingIcon({
                size: 24,
                className: clsx(iconsClassName[fieldState], 'tw-mr-1.6 tw-shrink-0')
            })
        ]
    });
};
const FormElementContainer_FormElementContainer = FormElementContainer;
export default FormElementContainer_FormElementContainer;
